import { useEffect, useState, useRef } from "react";
import { xcService } from "../../../_services/xcService";
import { useTranslation, withTranslation } from "react-i18next";
import { Avatar, Button, List, Select, Typography, Badge, Spin } from 'antd';
import { isBrowser } from 'react-device-detect';


import { LeftOutlined, FormOutlined, SendOutlined, LoadingOutlined } from "@ant-design/icons";
import * as _ from 'lodash';
import moment from "moment";
import { v1 as uuidv1 } from "uuid";
import variables from "../../../_constants/variables";
import localOrSessionStore from "_helpers/localOrSessionStore";
import TextArea from "antd/es/input/TextArea";

import config from "_config/config.js";
import { io } from "socket.io-client";
import { Radio } from 'antd';
import MessageMaster from "./messagemaster";

const { Option } = Select;


const MessageCenterMasterView = () => {
    const { t, i18n } = useTranslation();
    const [loading, setLoading] = useState(false);
    const storage = localOrSessionStore({ key: variables.REMEMBER });
    const [listChats, setListChats] = useState([]);
    const [chatSel, setChatSel] = useState(null);
    const [lastComment, setLastComment] = useState(null);
    const [lastSender, setLastSender] = useState(null);
    const [messages, setMessages] = useState([]);
    const userStorage = JSON.parse(storage.getItem(variables.USER));
    const [students, setStudents] = useState([]);
    const [tutors, setTutors] = useState([]);
    const [studentSel, setStudentSel] = useState(null);
    const [courseSel, setCourseSel] = useState(null)
    const [uuid, setUUID] = useState(null);
    const [toAdmin, setToAdmin] = useState(false);
    const user = JSON.parse(storage.getItem(variables.USER));
    const [newMessage, setNewMessage] = useState("");
    const userType = storage.getItem(variables.USER_TYPE);
    const [writing, setWriting] = useState(false);
    const [online, setOnline] = useState([])
    const scrollRef = useRef();
    const [value, setValue] = useState("COUNSELOR");

    //Socket
    const socket = useRef();


    const showDiff = (date) => {

        var duration = moment().diff(moment(date), 'days');
        if (moment(moment(date).format("YYYY-MM-DD")).isSame(moment().format("YYYY-MM-DD"))) {
            return moment(date).format("HH:mm")
        } else {
            if (duration < 5) {
                if (duration === 0) {
                    duration = 1;
                }
                return t("hace") + " " + duration + " " + (duration == 1 ? t("day") : t("days"));
            } else {
                return moment(date).format("DD/MM/YYYY hh:mm")
            }

        }
    }


    const getListChat = () => {
        setListChats([]);
        if (userType === "CENTER") {


            xcService.getToken('/v1/center/comments')
                .then(({ data }) => {
                    let mAgrupado = _.groupBy(data.data, "orientador_id");
                    let mLista = []
                    Object.keys(mAgrupado).map((key, i) => {
                        let order = _.orderBy(mAgrupado[key], ["createdAt"], ['desc']);
                        let mData = order[0];
                        mData.profile = "COUNSELOR"

                        mData.orientador = mData.tutor;

                        mLista.push(mData);


                    });

                    xcService.getToken('/v1/center/commentsmaster')
                        .then(({ data }) => {
                            let mAgrupado = _.groupBy(data.data, "center_id");
                            Object.keys(mAgrupado).map((key, i) => {
                                let order = _.orderBy(mAgrupado[key], ["createdAt"], ['desc']);
                                let mData = order[0];
                                mData.profile = "ADMIN"
                                mLista.push(mData);


                            });

                            setListChats(_.orderBy(mLista, ["createdAt"], ['desc']));

                            if (chatSel) {
                                let mTutorSel = data.data.filter(item => item.id === chatSel)
                                if (mTutorSel && mTutorSel[0]) {
                                    chatSelected(mTutorSel[0])
                                }
                            }
                        })

                    if (chatSel) {
                        let mTutorSel = data.data.filter(item => item.id === chatSel)
                        if (mTutorSel && mTutorSel[0]) {
                            chatSelected(mTutorSel[0])
                        }
                    }
                })


        } else {


            xcService.getToken('/v1/master/commentstutor')
                .then(({ data }) => {
                    let mAgrupado = _.groupBy(data.data, "orientador_id");
                    let mLista = []
                    Object.keys(mAgrupado).map((key, i) => {
                        let order = _.orderBy(mAgrupado[key], ["createdAt"], ['desc']);
                        let mData = order[0];
                        mData.profile = "COUNSELOR"
                        mLista.push(mData);


                    });

                    xcService.getToken('/v1/master/comentscenter')
                        .then(({ data }) => {
                            let mAgrupado = _.groupBy(data.data, "center_id");
                            Object.keys(mAgrupado).map((key, i) => {
                                let order = _.orderBy(mAgrupado[key], ["createdAt"], ['desc']);
                                let mData = order[0];
                                mData.profile = "CENTER"
                                mLista.push(mData);


                            });

                            setListChats(_.orderBy(mLista, ["createdAt"], ['desc']));

                            if (chatSel) {
                                let mTutorSel = data.data.filter(item => item.id === chatSel)
                                if (mTutorSel && mTutorSel[0]) {
                                    chatSelected(mTutorSel[0])
                                }
                            }
                        })

                    if (chatSel) {
                        let mTutorSel = data.data.filter(item => item.id === chatSel)
                        if (mTutorSel && mTutorSel[0]) {
                            chatSelected(mTutorSel[0])
                        }
                    }
                })


        }

    }


    useEffect(() => {

        getListChat();

        if (userType === "MASTER") {


            xcService.getToken('/v1/master/counselors')
                .then(({ data }) => data.data.map(tutor => {
                    return {
                        ...tutor,
                        orientador_id: tutor.id,
                        orientador: {id: tutor.id,name: tutor.name,
                            surname: tutor.surname, uuid: tutor.uuid },
                        name: tutor.name,
                        surname: tutor.surname
                    }
                }))
                .then(tutors => {

                    setTutors(tutors)
                })

            let mPayload = {
                xcelence: false,
                validados: true,
                validar: false,
                incompleto: false,
                towns: [],
                province: [],
                ccaa: [], codes: []
            }

            xcService.postToken(`/v1/master/centers`, mPayload)

                .then(({ data }) =>


                    data.data.map(center => {
                        return {
                            ...center,
                            center_id: center.id,

                            center: {id: center.id,name: center.name, uuid: center.uuid },
                            name: center.name.replaceAll("&quot;", "")
                        }
                    }))
                .then(centers => {

                    setStudents(centers)
                })
        } else {
            xcService.getToken(`/v1/center/counselors`)

                .then(({ data }) =>

                    data.data.map(tutor => {
                        return {
                            ...tutor,
                            orientador_id: tutor.id,
                            orientador: {id: tutor.id,name: tutor.name,
                                surname: tutor.surname, uuid: tutor.uuid  },
                            name: tutor.name,
                            surname: tutor.surname
                        }
                    }))
                .then(centers => {

                    setStudents(centers)
                    setTutors(centers)
                })
        }


        socket.current = io(config.socketUrl);

        socket.current.on("getMessage", (data) => {

            getListChat();
            if (chatSel) {
                chatSelected(chatSel)

            }
        });
        socket.current.emit("addUser", userType === "CENTER" ?  user.uuid : "ADMIN");
        socket.current.on("getUsers", (users) => {
            setOnline(users)
        });


    }, []
    )


    const onChange = (e) => {
        setNewMessage(e.target.value);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        sendChat();
    };


    const onchangeGroup = (value) => {
        setCourseSel(value);

    };

    const onSearchGroup = (value) => {
    };

    const onChangeStudent = (val) => {

        if (userType === "CENTER") {
            setStudentSel(val);

            let mTemp = students.filter(it => it.id === val);
            if (mTemp && mTemp[0]) {

                setChatSel(mTemp[0]);
                setUUID(mTemp[0].uuid)
            }
        } else {

            if (value === "CENTER") {
                setStudentSel(val);

                let mTemp = students.filter(it => it.id === val);
                if (mTemp && mTemp[0]) {

                    setChatSel(mTemp[0]);
                    setUUID(mTemp[0].uuid)
                }
            } else {
                setStudentSel(val);

                let mTemp = tutors.filter(it => it.id === val);
                if (mTemp && mTemp[0]) {

                    setChatSel(mTemp[0]);
                    setUUID(mTemp[0].uuid)
                }
            }
        }
    };

    const onSearchStudent = (value) => {
    };


    const emitSocket = (rec, send, text) => {
        socket.current.emit("sendMessage", {
            receiverId: rec,
            senderId: send,
            text: text,
        });

        socket.current.emit("sendMessage", {
            receiverId: "A_" + rec,
            senderId: send,
            text: text,
        });
    }

    const sendChat = () => {

        let mUUID;
        let mOrientador = null;
        if (userType === "CENTER"){
            let mChatSel;
            if (!chatSel){
               mChatSel = {};
               mChatSel.profile = "ADMIN"
            }else{
                mChatSel=chatSel;
            }
            if (toAdmin){
                mChatSel.profile = "ADMIN"
            }else{
                mChatSel.profile = "COUNSELOR"
            }
            if (mChatSel && mChatSel.profile === "COUNSELOR"){
                let mId = mChatSel.id;
                if (chatSel && chatSel.orientador_id){
                    mId=chatSel.orientador_id
                }else{
                    mId=chatSel.id
                }
                let payload = {
                    to: mId,
                    comment: newMessage
                };
                xcService.postToken('/v1/center/comment', payload)
                    .then(({data}) => {

                        setValue("COUNSELOR")
                        let mUUID = "";
                        if (chatSel.tutor){
                            mUUID=chatSel.tutor.uuid
                        }else{
                            mUUID = chatSel.uuid
                        }
                        emitSocket(mUUID, chatSel.center.uuid, newMessage);
                        setNewMessage("")
                        setWriting(false)
                        getListChat()
                        if (chatSel) {

                            let mId = chatSel.center_id;
                            if (chatSel.profile === "COUNSELOR"){
                                let mId = chatSel.id;
                                if (chatSel && chatSel.orientador_id){
                                    mId=chatSel.orientador_id
                                }else{
                                    mId=chatSel.tutor.id
                                }
                            } else {
                                mId = "ADMIN"
                            }
                            getMessages(mId, chatSel)
                        }

                    });
            }else{
                let payload = {
                    comment: newMessage
                };
                xcService.postToken('/v1/center/commentsmaster', payload)
                    .then(({data}) => {
                        setValue("ADMIN")
                        setToAdmin(true)
                        emitSocket("ADMIN", mChatSel.center ? mChatSel.center.uuid : user.uuid, newMessage);

                        setNewMessage("")
                        setWriting(false)
                        getListChat()
                        if (chatSel) {

                            let mId = chatSel.center_id;
                            if (mChatSel.profile === "COUNSELOR"){
                                mId = mChatSel.orientador_id;
                            } else {
                                mId = mChatSel.center_id
                            }
                            getMessages(mId, chatSel)
                        }

                    });
            }
        }else{


            if (chatSel.profile === "COUNSELOR"){
                let payload = {
                    to: chatSel.orientador_id,
                    comment: newMessage
                };
                xcService.postToken('/v1/master/commenttutor', payload)
                    .then(({data}) => {

                        emitSocket(chatSel.tutor ? chatSel.tutor.uuid : chatSel.uuid, "ADMIN", newMessage);
                        setNewMessage("")
                        setWriting(false)
                        getListChat()
                        if (chatSel) {

                            let mId = chatSel.center_id;
                            if (chatSel.profile === "COUNSELOR"){
                                mId = chatSel.orientador_id;
                            } else {
                                mId = chatSel.center_id
                            }
                            getMessages(mId, chatSel)
                        }

                    });
            }else{
                let payload = {
                    to: chatSel.center_id,
                    comment: newMessage
                };
                xcService.postToken('/v1/master/comentcenter', payload)
                    .then(({data}) => {

                        emitSocket(chatSel.center.uuid, "ADMIN", newMessage);

                        setNewMessage("")
                        setWriting(false)
                        getListChat()
                        if (chatSel) {

                            let mId = chatSel.center_id;
                            if (chatSel.profile === "COUNSELOR"){
                                mId = chatSel.orientador_id;
                            } else {
                                mId = chatSel.center_id
                            }
                            getMessages(mId, chatSel)
                        }

                    });
            }

        }
    }
        ;


    useEffect(() => {
        socket.current = io(config.socketUrl);
        return () => {

            socket.current.emit("removeUser", user.uuid);
        };
    }, []);


    const chatSelected = (item) => {



        let mId = item.center_id;
        let mUUID = item.uuid;

        if (item.profile === "CENTER"){
            mId = item.center_id;
            mUUID = item.center.uuid;
        }else{
            if (item.profile === "ADMIN"){
                mUUID = "ADMIN"
            }else {
                mId = item.orientador_id;
                mUUID = item.tutor ? item.tutor.uuid : item.orientador ? item.orientador.uuid : item.uuid;
            }
        }


        setWriting(false)
        setChatSel(item);
        setUUID(mUUID)


        socket.current = io(config.socketUrl);

        socket.current.on("getMessage", (data) => {
            setLastComment(data.text);
            setLastSender(data)
            getMessages(mId, item);

        });

        /*
        socket.current.emit("addUser", user.uuid ?? "master");
        socket.current.on("getUsers", (users) => {
        });

        */


        getMessages(mId, item);

    }

    const getMessages = (id, item) => {

        setLoading(true)
        setToAdmin(false)
        setMessages([])
        if (userType === "CENTER") {
            if (item.profile === "COUNSELOR"){
                xcService.getToken(`/v1/center/comments/${id}`)
                    .then(({data}) => {
                        setLoading(false);
                        setMessages(data.data);
                    }).catch(e => setLoading(false));
            }else {
                xcService.getToken(`/v1/center/commentsmaster`)
                    .then(({data}) => {
                        setLoading(false);
                        setMessages(data.data);
                    }).catch(e => setLoading(false));
            }
        } else {
            if (item.profile === "CENTER"){
                xcService.getToken(`/v1/master/comentcenter/${id}`)
                    .then(({ data }) => {
                        setLoading(false);
                        setMessages(data.data);
                    }).catch(e => setLoading(false));
            }else{
                xcService.getToken(`/v1/master/commenttutor/${id}`)
                    .then(({ data }) => {
                        setLoading(false);
                        setMessages(data.data);
                    }).catch(e => setLoading(false));
            }

        }
    }


    useEffect(() => {
        if (chatSel) {
            let scrollToBot = document.getElementById('content-chat');
            if (scrollToBot) {

                scrollToBot.scrollTop = scrollToBot.scrollHeight;
            }
        }
    }, [messages]);


    const getStudents = () => {


        return students


    }

    const onChangeToAdmin = (e) => {
        setToAdmin(e.target.checked);
    };

    const isOnline = (item) => {

        try {
            let mUUID = "ADMIN";
            if (item.sendByOrientador || item.toOrientador){
                mUUID = item.tutor.uuid;
            }
            if (item.sendByCenter || item.toCenter){
                mUUID = item.center.uuid;
            }

            let mEsta = online.filter((user) => user.userId === mUUID);
            return mEsta.length > 0;
        } catch (e) {
            return false;
        }
    }

    const goWrite = () => {
        setWriting(true);
        setChatSel(null)
    }


    const onChangeR = (e) => {

        setValue(e.target.value);
        setToAdmin(e.target.value === "ADMIN")

    };
    return (
        <>
            <div className={"container container--messages boxed boxed--admin-default"}>
                <div className={"content-messages-top"}>
                    <h1>{t("mensajes.title")}</h1>
                    <Button type="primary"
                        onClick={() => goWrite()}
                        size={'large'} shape="round" icon={<FormOutlined />}>{t("mensajes.redactar")}
                    </Button>


                </div>
                <p>{userType === "CENTER" ? t("mensajes.descenter") : t("mensajes.desmaster")}</p>


                <>
                    <div className={`content-messages-mid ${(chatSel || writing) && "is-select-chat"}`}>
                        <div className={"content-messages-left"}>
                            <List
                                itemLayout="horizontal"
                                dataSource={listChats}
                                renderItem={(item) => (

                                    <List.Item
                                        className={`preview-chat ${chatSel &&
                                            (userType === "MASTER" && item.profile === "CENTER" && item.center_id === chatSel.center_id) ?
                                            "preview-chat--select" :
                                            chatSel && (userType === "MASTER" && item.profile === "COUNSELOR" && item.orientador_id === chatSel.orientador_id) ?
                                                "preview-chat--select" :
                                            chatSel && (userType == "CENTER" && item.orientador_id === chatSel.orientador_id) ?
                                                "preview-chat--select" :

                                                "preview-chat--not-select"
                                            }`}
                                        onClick={(e) => {
                                            chatSelected(item)
                                        }}>
                                        <div className={"preview-chat-top"}>

                                            {isOnline(item) ? <Badge color="green" /> : <></>}
                                            {item?.avatar ? <Avatar className={"icon"} src={item?.avatar} /> :
                                                <Avatar className={"icon"}>{item?.name}</Avatar>}
                                            <div className={"name"}>{
                                                userType === "MASTER" ? item.orientador_id ? item?.tutor?.name + " " + item?.tutor?.surname : item.center.name :
                                                    userType === "CENTER" ?
                                                        item.center_id && item.orientador_id ? item?.tutor?.name + " " + item?.tutor?.surname :
                                                            "Admin Orion" : "Admin Orion2"}</div>
                                            <div className={"data"}>{showDiff(item.createdAt)}</div>
                                        </div>
                                        {<div className={"preview-chat-bottom"}>

                                            {item.comment}
                                        </div>}
                                    </List.Item>
                                )}
                            />


                        </div>
                        <div className={"content-messages-right"}>
                            {!isBrowser &&
                                <Button size={'large'} onClick={() => setChatSel(null)} type="primary"
                                    icon={<LeftOutlined />}>
                                    {t("atras")}
                                </Button>

                            }
                            {writing &&
                                <>

                                    <div><Radio.Group onChange={onChangeR} value={value}>
                                        <Radio value={"COUNSELOR"}>{t("menu.orienta")}</Radio>
                                        {userType === "MASTER" &&
                                            <Radio value={"CENTER"}>{t("menu.centros")}</Radio>}
                                        {userType === "CENTER" && <Radio value={"ADMIN"}>{t("toMyAdmin")}</Radio>}
                                    </Radio.Group></div>

                                    {value === "CENTER" &&
                                        <Select

                                            size={'large'}
                                            style={{ width: 360 }}
                                            showSearch
                                            placeholder={t("mensajes.para")}
                                            optionFilterProp="children"
                                            onChange={onChangeStudent}
                                            onSearch={onSearchStudent}
                                            filterOption={(input, option) => {

                                                let mSearch = input.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "")

                                                return (option?.label ?? '').toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "").includes(mSearch)

                                            }
                                            }>
                                            {getStudents().map(tutor => {
                                                return <Option key={tutor.id} value={tutor.id}
                                                    label={userType === "CENTER" ? tutor.name + " " + tutor.surname : tutor.name}>
                                                    {
                                                        userType === "CENTER" ?
                                                            tutor.name + " " + tutor.surname + " (" + (tutor.profile === "COUNSELOR" ? t("isOrientador") : t("isTutor")) + ")"
                                                            : tutor.name + " (" + t("isCenterE") + ")"}</Option>
                                            })
                                            }

                                        </Select>
                                    }
                                    {value === "COUNSELOR" &&
                                        <Select

                                            size={'large'}
                                            style={{ width: 360 }}
                                            showSearch
                                            placeholder={t("mensajes.para")}
                                            optionFilterProp="children"
                                            onChange={onChangeStudent}
                                            onSearch={onSearchStudent}
                                            filterOption={(input, option) => {

                                                let mSearch = input.toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "")

                                                return (option?.label ?? '').toLowerCase().normalize("NFD").replace(/\p{Diacritic}/gu, "").includes(mSearch)

                                            }
                                            }>
                                            {tutors.map(tutor => {
                                                return <Option key={tutor.id} value={tutor.id}
                                                    label={tutor.name + " " + tutor.surname}>
                                                    {
                                                        tutor.name + " " + tutor.surname}</Option>
                                            })
                                            }

                                        </Select>
                                    }

                                    <div className="content-chat-box" style={{ marginTop: "16px" }}>
                                        <TextArea
                                            className="chat-box-input"
                                            style={{ resize: "none", height: "70px", padding: "12px 56px 4px 12px" }}
                                            onChange={onChange} />
                                        <Button
                                            onClick={() => sendChat()}
                                            shape="circle"
                                            type="primary"
                                            size="large"
                                            icon={<SendOutlined />}
                                        ></Button>
                                    </div>
                                </>
                            }
                            {!writing && chatSel &&
                                <>
                                    <div id={"content-chat"} className={"content-chat-messages"}>
                                        {!loading ?
                                            <div id={"messages"} className={"messages"}>
                                                {messages && messages.map(item => {

                                                    return <div key={uuidv1()} ref={scrollRef}><MessageMaster
                                                        user={user}
                                                        t={t}
                                                        key={uuidv1()}
                                                        item={item} />
                                                    </div>

                                                })}
                                            </div>
                                            :
                                            <Spin indicator={<LoadingOutlined style={{ fontSize: 100 }} spin />} />
                                        }
                                    </div>
                                    <div className="content-chat-box">
                                        <TextArea allowClear
                                            value={newMessage}
                                            className="chat-box-input"
                                            placeholder={`${t("quedecir")}, ${user.name}?`}
                                            onChange={onChange}
                                        />

                                        <Button
                                            onClick={(e) => handleSubmit(e)}
                                            shape="circle"
                                            type="primary"
                                            size="large"
                                            icon={<SendOutlined />}
                                        />
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </>

            </div>
        </>)


}


export default withTranslation()(MessageCenterMasterView);
